/**
 * ButtonSupportive
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Link as LinkBase } from 'ui-component-library/base';
/** A reusable button component. */
var ButtonSupportive = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'grey' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'rounded' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.LinkComponent, LinkComponent = _f === void 0 ? LinkBase : _f, _g = _a.as, as = _g === void 0 ? 'button' : _g, onClick = _a.onClick, htmlAttributes = __rest(_a, ["children", "color", "className", "variant", "disabled", "LinkComponent", "as", "onClick"]);
    var Link = LinkComponent;
    var tagMapper = {
        button: 'button',
        a: Link || 'a',
    };
    var Component = tagMapper[as];
    return (React.createElement(Component, __assign({ disabled: disabled, className: clsx(className, 'inline-block', 'outline-none', 'h-8', 'text-p', 'whitespace-no-wrap', as === 'a' && 'py-0.5 hover:cursor-pointer', variant === 'rounded' && 'rounded-full px-2.5', variant === 'squared' && 'rounded px-2', disabled && ['bg-greyLight', 'text-greyDark'], !disabled &&
            color === 'grey' && [
            'bg-greyLight',
            'border-2',
            'border-greyLight',
            'text-teal',
            'hover:bg-greySemiLight',
            'hover:border-greySemiLight',
        ], !disabled &&
            color === 'teal' && [
            'bg-teal',
            'border-2',
            'border-teal',
            'text-white',
            'hover:bg-teal-hover',
            'hover:border-teal-hover',
        ]), onClick: onClick, "data-cid": "Button" }, htmlAttributes), children));
};
export default ButtonSupportive;
